import { useQuery, QueryObserverBaseResult } from "react-query"
import { queryKeys } from "../query"
import api from "../client"
import { ConstantsResponseData } from "../types/constants"

const getData = async () => {
  const { data } = await api.get(`/constants`)
  return data
}

export const useConstants = (): QueryObserverBaseResult<ConstantsResponseData> => {
  const { data, ...props } = useQuery<ConstantsResponseData>(
    queryKeys.CONSTANTS,
    () => getData(),
    { retry: 5 }
  )
  return { data, ...props }
}
